export class ArticleContentException extends Error {
  constructor(message = 'An error occurred while getting the article content', options?: ErrorOptions) {
    super(message, options);
    this.name = 'ArticleContentException';
  }
}
